import { Stack, Typography } from "@mui/material"
import TextInput from "components/files/TextInput"
import NullCheck from "components/NullCheck"
import { BIZ_TYPE, DATE_TIME_FORMAT } from "config/const"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useBizType } from "hooks/useBizType"
import CustomCard from "components/CustomCard"
import { PhoneInTalk } from "@mui/icons-material"
import CustomIconButton from "components/CustomIconButton"
import EmpAndDate from "./EmpAndDate"
import Works from "./Works"
import ReplacedParts from "./ReplacedParts"
import { useEffect, useState } from "react";

const Global = ({
  control,
  data,
  errors,
  setWorkDt,
  setValue,
  watch,
  workDt,
  empList,
  stTypeId,
  workEndDt,
  isMobile,
  editHasFlag,
  worksList,
  setWorksList,
  replacedPartsList,
  setReplacedPartsList,

}) => {
  const { bt } = useBizTypeTranslation();
  const { bizTypeCheck } = useBizType()
  const [contentWithItems, setContentWithItems] = useState([])

  useEffect(() => {
    if (data?.contentWithItems?.length > 0) {
      const newList = data.contentWithItems.map(text => cleanText(text));
      setContentWithItems(newList);
      setValue("contentWithItems", newList);
    }
  }, [data, setValue]);

  const cleanText = (text = '') => {
    return String(text)
      .replace(/\s+/g, ' ')
      .replace(/\s*-\s*/g, ' - ')
      .trim();
  };

  console.log("contentWithItems", contentWithItems);
  return (
    <Stack spacing={1} pb={2}>
      <Stack
        width="100%"
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        justifyContent="space-between"
      >
        <CustomCard fullWidth>
          <Stack direction="row" spacing={2} alignItems="center">
            <NullCheck valueForCheck={data?.clienCompany}>
              <Typography variant="body2">
                {`${data?.clienCompany}`}
              </Typography>
            </NullCheck>

            <NullCheck valueForCheck={data?.name}>
              <TextInput
                addFlex
                errors={errors}
                standard
                name="name"
                title=""
                control={control}
              />
            </NullCheck>

            <NullCheck valueForCheck={data?.tel}>
              <Stack sx={{ flex: 1, maxWidth: isMobile ? "auto" : "30%" }} direction='row' alignItems='center'>
                <CustomIconButton
                  size={30}
                  hideBgcolor
                  icon={<PhoneInTalk fontSize="small" />}
                  href={`tel:${data?.tel}`}
                />
                <TextInput
                  addFlex
                  errors={errors}
                  standard
                  name="tel"
                  title=""
                  control={control}
                />
              </Stack>
            </NullCheck>

          </Stack>
        </CustomCard>

        <CustomCard fullWidth>
          <Stack direction="row" spacing={2}>

            {bizTypeCheck(BIZ_TYPE.SERVICE_PROVIDER)
              ?
              <Stack direction="row" spacing={1}>
                <Typography fontSize={12}>{bt("CLIENT_CALL_ID")}:</Typography>

                <TextInput
                  addFlex
                  width="100%"
                  errors={errors}
                  standard
                  name="clientCallId"
                  title=""
                  control={control}
                />
              </Stack>
              : null
            }

            <Stack direction="row" spacing={1}>
              <Typography fontSize={12}>{bt("ADDR")}:</Typography>

              <TextInput
                addFlex
                width="100%"
                errors={errors}
                standard
                name="addr"
                title=""
                control={control}
              />
            </Stack>
          </Stack>

        </CustomCard>
      </Stack>

      <EmpAndDate
        setWorkDt={setWorkDt}
        דsetValue={setValue}
        watch={watch}
        workDt={workDt}
        control={control}
        data={data}
        empList={empList}
        errors={errors}
        stTypeId={stTypeId}
        workEndDt={workEndDt}
        editHasFlag={editHasFlag}
      />

      {contentWithItems && contentWithItems[0] !== ""
        ? <CustomCard>
          <Stack direction="row" >
            <Typography fontSize={14}>{bt("DESC_PROBLEM")}:</Typography>

            <Stack width="90%">
              {contentWithItems?.map((item, index) => {
                return (
                  <TextInput
                    width="100%"
                    textBold
                    errors={errors}
                    name={`contentWithItems[${index}]`}
                    title=""
                    readOnly
                    rows
                    control={control}
                  />
                )
              })}
            </Stack>
          </Stack>
        </CustomCard>
        : null
      }

      <Works
        setValue={setValue}
        watch={watch}
        control={control}
        data={data}
        errors={errors}
        list={worksList}
        setList={setWorksList}
      />

      <ReplacedParts
        setValue={setValue}
        watch={watch}
        control={control}
        data={data}
        errors={errors}
        list={replacedPartsList}
        setList={setReplacedPartsList}
      />


    </Stack>
  )
}
export default Global